import { useState } from 'react';
import { FaEdit, FaPlus, FaSpinner, FaTrash } from 'react-icons/fa';
import CardLayout from '../common/CardLayout';
import ConfirmDeleteModal from '../admin/ConfirmDeleteModal';
import { Dialog, DialogTrigger } from '../ui/dialog';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import TabelaItensManutencao from './TabelaItensManutencao';
import DialogTabelaManutencao from './DialogTabelaManutencao';
import { nomeTipoEquipamento } from './periodicidades';

export default function ListaTabelasManutencao({
    tabelas,
    carregando,
    erroCarregamento,
    podeEditar,
    onTentarNovamente,
    onCriarTabela,
    onEditarTabela,
    onExcluirTabela,
    onCarregarModeloPadrao,
    onCriarItem,
    onEditarItem,
    onExcluirItem,
}) {
    const [tabelaAberta, setTabelaAberta] = useState('');
    const [dialogTabela, setDialogTabela] = useState({ aberto: false, tabela: null });
    const [tabelaParaExcluir, setTabelaParaExcluir] = useState(null);
    const [carregandoModelo, setCarregandoModelo] = useState(false);

    const carregarModelo = async () => {
        if (carregandoModelo) return;
        setCarregandoModelo(true);
        try {
            await onCarregarModeloPadrao();
        } finally {
            setCarregandoModelo(false);
        }
    };

    const salvarTabela = (dados) =>
        dialogTabela.tabela ? onEditarTabela(dialogTabela.tabela.id, dados) : onCriarTabela(dados);

    return (
        <div className="p-2">
            <CardLayout>
                <div className="flex items-center justify-between gap-2 p-2 flex-wrap">
                    <h2 className="text-2xl font-semibold">Edição de tabelas de manutenção</h2>
                    {podeEditar && (
                        <button
                            type="button"
                            onClick={() => setDialogTabela({ aberto: true, tabela: null })}
                            className="flex items-center gap-2 bg-accent text-white px-3 py-1.5 rounded-md text-lg"
                        >
                            <FaPlus /> Nova tabela
                        </button>
                    )}
                </div>

                {carregando && tabelas.length === 0 ? (
                    <div className="flex justify-center p-4 text-gray-400"><FaSpinner className="animate-spin" /></div>
                ) : erroCarregamento && tabelas.length === 0 ? (
                    <div className="flex items-center justify-center gap-2 p-4 text-lg text-gray-300">
                        Não foi possível carregar as tabelas.
                        <button type="button" onClick={onTentarNovamente} className="text-accent underline">Tentar novamente</button>
                    </div>
                ) : tabelas.length === 0 ? (
                    <div className="flex flex-col items-center justify-center gap-3 p-4 mb-2 text-lg text-gray-300 border border-gray-700 rounded-lg bg-darkaccent/40" role="status">
                        Nenhuma tabela de manutenção cadastrada nesta unidade.
                        {podeEditar && (
                            <button
                                type="button"
                                onClick={carregarModelo}
                                disabled={carregandoModelo}
                                className="flex items-center gap-2 bg-gray-800 text-white border border-gray-700 px-3 py-1.5 rounded-md text-lg disabled:opacity-50"
                            >
                                {carregandoModelo && <FaSpinner className="animate-spin" />}
                                Carregar modelo padrão
                            </button>
                        )}
                    </div>
                ) : (
                    <Dialog>
                        <Accordion type="single" collapsible value={tabelaAberta} onValueChange={setTabelaAberta} className="px-2">
                            {tabelas.map((tabela) => (
                                <AccordionItem key={tabela.id} value={`tabela-${tabela.id}`} className="border-b border-gray-800/60">
                                    <AccordionTrigger>
                                        <div className="flex w-full items-center gap-3 pr-3 text-left">
                                            <span className="font-semibold uppercase">{tabela.nome}</span>
                                            {tabela.tipoEquipamento && (
                                                <span className="text-base px-2 py-0.5 rounded bg-accent/30 text-white">
                                                    Todos os {nomeTipoEquipamento(tabela.tipoEquipamento).toLowerCase()}
                                                </span>
                                            )}
                                            <span className="ml-auto text-base text-gray-400">{tabela.itens.length} ações</span>
                                        </div>
                                    </AccordionTrigger>
                                    <AccordionContent>
                                        {podeEditar && (
                                            <div className="flex justify-end gap-3 px-2 pb-2">
                                                <button
                                                    type="button"
                                                    onClick={() => setDialogTabela({ aberto: true, tabela })}
                                                    className="flex items-center gap-1 text-lg text-accent"
                                                >
                                                    <FaEdit /> Editar tabela
                                                </button>
                                                <DialogTrigger
                                                    onClick={() => setTabelaParaExcluir(tabela)}
                                                    className="flex items-center gap-1 text-lg text-red-400"
                                                >
                                                    <FaTrash /> Excluir tabela
                                                </DialogTrigger>
                                            </div>
                                        )}
                                        <TabelaItensManutencao
                                            tabela={tabela}
                                            podeEditar={podeEditar}
                                            onCriar={onCriarItem}
                                            onEditar={onEditarItem}
                                            onExcluir={onExcluirItem}
                                        />
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                        <ConfirmDeleteModal
                            itemNome={tabelaParaExcluir?.nome}
                            descricao={`A tabela ${tabelaParaExcluir?.nome ?? ''} e suas ações deixarão de gerar tarefas.`}
                            onConfirm={() => tabelaParaExcluir && onExcluirTabela(tabelaParaExcluir.id)}
                        />
                    </Dialog>
                )}
            </CardLayout>

            <DialogTabelaManutencao
                aberto={dialogTabela.aberto}
                tabela={dialogTabela.tabela}
                onFechar={() => setDialogTabela({ aberto: false, tabela: null })}
                onSalvar={salvarTabela}
            />
        </div>
    );
}
